import { useCallback } from "react";
import { registerFrameAnchor, type FrameAnchorKind } from "@/lib/frame-anchors";

/**
 * A callback ref that registers its element as frame `id`'s `kind` anchor
 * (`lib/frame-anchors.ts`) while mounted; a null id registers nothing.
 */
export function useFrameAnchor(
  id: string | null,
  kind: FrameAnchorKind,
): (element: HTMLElement | null) => (() => void) | undefined {
  return useCallback(
    (element: HTMLElement | null) =>
      element && id !== null
        ? registerFrameAnchor(kind, id, element)
        : undefined,
    [id, kind],
  );
}
